(function($) {
    $(document).ready(function() {
        var leuserfund = $('.leuserfund-donation');
        // Make contact with the ip info service
        $.get("https://ipinfo.io", function(response) {
            // If the current IP is in Great Britain
            if (leuserfund.length) {
                // Tick the box that says the user is in the UK
                $('.check--uk').prop('checked', false); 
                // And show the gift aid stuff
                $('.gift-aid').hide();
            } else if (response.country === 'GB') {
                // Tick the box that says the user is in the UK
                $('.check--uk').prop('checked', true); 
                // And show the gift aid stuff
                $('.gift-aid').show();
                // If not from GB
            } else {

                //Make sure the box is not ticked
                $('.check--uk').prop('checked', false); 
                // And hide the gift aid
                $('.gift-aid').hide();
            }
            // Return in JSON
        }, "jsonp");


    });
})(jQuery);
